import { render } from "./TeamCalendar.vue?vue&type=template&id=3d45723e"
import script from "./TeamCalendar.vue?vue&type=script&lang=js"
export * from "./TeamCalendar.vue?vue&type=script&lang=js"

import "./TeamCalendar.vue?vue&type=style&index=0&id=3d45723e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__